import { Comscore1PIdentifierType } from '../utils';
import { getNetworkIdFromCookie, getUrsDatabaseIdFromCookie } from './utils';
const trackComscorePageView = () => {
    const beaconCall = (csConsent) => {
        if (window && window.COMSCORE) {
            const UrsDatabaseId = getUrsDatabaseIdFromCookie();
            const networkID = getNetworkIdFromCookie();
            window.COMSCORE.beacon({
                c1: '2',
                c2: '6035755',
                cs_ucfr: csConsent,
                cs_fpid: UrsDatabaseId || networkID,
                cs_fpit: UrsDatabaseId ? Comscore1PIdentifierType.LOGGED_IN_ID : Comscore1PIdentifierType.LOGGED_OUT_ID,
                options: {
                    enableFirstPartyCookie: true,
                },
            });
        }
        else {
            console.log('window.COMSCORE not defined');
        }
    };
    if (window && window.__tcfapi) {
        // See https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#addeventlistener
        window.__tcfapi('addEventListener', 2, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (tcData, success) {
            let csConsent = '';
            if (success && // Listener added successfully
                tcData.eventStatus === 'tcloaded' && // TC string is available and CMP will not show UI
                tcData.vendor.consents['77'] !== undefined // Comscore vendor consent is present
            ) {
                tcData.vendor.consents['77'] ? (csConsent = '1') : (csConsent = '0');
            }
            // Un-register listener to avoid calling beacon multiple times for future trackComscorePageView calls
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            window.__tcfapi('removeEventListener', 2, () => { }, tcData.listenerId);
            beaconCall(csConsent);
        }, [77]);
    }
    else {
        beaconCall('');
    }
};
export { trackComscorePageView };
